import { getResourceId } from '@eigtech/shared-corn'
import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { ROUTER_PATHS } from '@/lib/constants'
import { ButtonGroup, ComposedCard, Page } from '@eigtech/ui-shared-dave'
import { MeetingDetailsWithoutChimeEvents, MeetingsTable } from '@eigtech/ui-shared-meetings'
import { LinkButton, LinkMenuItem } from '@eigtech/ui-shared-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/meetings')({
  component: ClaimDetailMeetings,
})

function ClaimDetailMeetings() {
  const { claimNumber } = Route.useParams()

  return (
    <Page
      heading="Meetings"
      toolbarItems={[
        <LinkButton
          key="createOfflineMeeting"
          params={{ claimNumber }}
          to={ROUTER_PATHS.claimDetailNewMeetingFromVideoUpload.route}
          variant="solid"
        >
          Upload Video as Meeting
        </LinkButton>,
        <LinkButton
          key="startMeeting"
          params={{ claimNumber }}
          to={ROUTER_PATHS.claimDetailNewMeeting.route}
          variant="solid"
        >
          Start New Meeting
        </LinkButton>,
      ]}
    >
      <ComposedCard>
        <MeetingsTable
          ActionButtons={ActionButtons}
          ActionMenuItems={ActionMenuItems}
          entityId={ensureClaimCorn(claimNumber)}
        />
      </ComposedCard>
    </Page>
  )
}

function ActionMenuItems({ meetingId, entityId, startTime }: MeetingDetailsWithoutChimeEvents) {
  return (
    <LinkMenuItem
      params={{ claimNumber: getResourceId(entityId), meetingStartTime: startTime, meetingId }}
      to={ROUTER_PATHS.claimDetailMeeting.route}
    >
      Open Meeting
    </LinkMenuItem>
  )
}

function ActionButtons({
  meetingId,
  entityId,
  startTime,
  status,
}: MeetingDetailsWithoutChimeEvents) {
  return (
    <ButtonGroup>
      {status === 'active' && (
        <LinkButton
          params={{ claimNumber: getResourceId(entityId), meetingStartTime: startTime, meetingId }}
          size="sm"
          to={ROUTER_PATHS.claimDetailMeeting.route}
        >
          Join Meeting
        </LinkButton>
      )}
    </ButtonGroup>
  )
}
